import { render, staticRenderFns } from "./PointBitcash.vue?vue&type=template&id=065e4d46"
import script from "./PointBitcash.vue?vue&type=script&lang=js"
export * from "./PointBitcash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports